// source: template-project@7007a338a apps/backoffice/src/app-shell/shell-classes.ts (INSET_BORDER_CLASS, INSET_PROVIDER_CLASS, INSET_PANEL_CLASS verbatim)
/*
 * The /app framing, as class strings. Full literals, so Tailwind sees them (its content glob covers src/**).
 */

/** A hairline round the panel, so it reads as a panel on the rail's ground in dark too. The panel is flat. */
export const INSET_BORDER_CLASS = 'border border-border md:peer-data-[variant=inset]:shadow-none';

/** Inset: the provider wrapper is the rail's ground (`--sidebar-bg` is a custom property), the page a rounded panel on it. */
export const INSET_PROVIDER_CLASS = '[background:var(--sidebar-bg)]';

/** The inset panel's geometry: 8px in on the top, right and bottom, flush against the rail on the left, rounded, clipped. */
export const INSET_PANEL_CLASS = `m-2 ml-0 overflow-hidden rounded-xl bg-[var(--tf-bg-page,var(--background))] ${INSET_BORDER_CLASS}`;
